import {
  Typography,
  Button,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Table,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/footer";
import google from "../image/google.png";
import app from "../image/app.png";
import mobile from "../image/phone.svg";
import "../css/order_summary.css";
import Offer from "../components/offer";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import DeleteIcon from "@mui/icons-material/Delete";

const OrderSummary = () => {
  // let navigate = useNavigate();
  // const location = useLocation();
  // const viewData = location.state;

  const [cartData, setCartData] = useState([]);
  const [itemTotal, setItemTotal] = useState("");
  const [isOrderSuccess, setOrderSuccess] = useState(false);
  const [isRemoveDialogOpen, setRemoveDialogOpen] = useState(false);
  console.log("cartData", cartData);
  const navigate = useNavigate();

  const location = useLocation();
  const applicableTax = location?.state?.applicableTax;
  const cartQuantity = location?.state?.cartQuantities;

  console.log("cartQuantity", cartQuantity);

  const deliveryFee = 100;
  const [selectedType, setSelectedPayment] = useState("");
  const handleChangeRadio = (event) => {
    console.log(event.target.value);
    setSelectedPayment(event.target.value);
  };
  const [offers, setOffers] = useState([]);
  useEffect(() => {
    getOffers();
    window.scroll(0, 0);
  }, [cartData]);
  const getOffers = async () => {
    try {
      const res = await axios.get(`http://api.meddaily.in/getoffer`);
      if (res.status === 200) {
        const offersData = res?.data?.data;
        const matchingOffers = offersData.filter((offer) => {
          return cartData.some(
            (item) =>
              item.product_id === offer.product_id ||
              item.distributor_id === offer.distributor_id
          );
        });

        setOffers(matchingOffers);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    axios
      .get("http://api.meddaily.in/get_cart", {
        headers: { token: sessionStorage.getItem("token") },
      })
      .then((res) => {
        setCartData(res?.data?.data);
        console.log("object", res);
      })
      .catch((error) =>
        console.error("Error fetching category product data:", error)
      );
  }, []);

  useEffect(() => {
    // Calculate item total
    // const total = cartData.reduce((accumulator, cart) => accumulator + (cart.price * cart.quantity), 0);
    // setItemTotal(total);
    // const total = cartData.reduce((accumulator, cart) => {
    //   const quantity = parseInt(cartQuantity); // Convert quantity to number
    //   const price = parseInt(cart.price);
    //   return accumulator + price * quantity;
    // }, 0);
    // setItemTotal(total);
    const total = cartData?.reduce((accumulator, cart) => {
      const quantity = parseInt(cart.quantity); // Convert quantity to number
      const price = parseInt(cart.price);
      return accumulator + price * quantity;
    }, 0);
    setItemTotal(total);
  }, [cartData]);

  const [quantity, setQuantity] = useState("");

  const incrementQuantity = (id) => {
    // setQuantity(cartData.quantity + 1);
    const updatedCartData = cartData.map((cart) => {
      if (cart._id === id) {
        return {
          ...cart,
          quantity: cart.quantity + 1,
        };
      }
      return cart;
    });
    setCartData(updatedCartData);
  };

  const decrementQuantity = (id) => {
    // if (quantity > 0) {
    //   setQuantity(cartData.quantity - 1);
    // }
    const updatedCartData = cartData.map((cart) => {
      if (cart._id === id && cart.quantity > 0) {
        return {
          ...cart,
          quantity: cart.quantity - 1,
        };
      }
      return cart;
    });
    setCartData(updatedCartData);
  };

  // const handleQuantityChange = (e) => {
  //   const newQuantity = Number(e.target.value);
  //   setQuantity(newQuantity);
  // };

  const handleQuantityChange = (id, e) => {
    const newQuantity = parseInt(e.target.value);
    const updatedCartData = cartData.map((cart) => {
      if (cart._id === id) {
        return {
          ...cart,
          quantity: newQuantity,
        };
      }
      return cart;
    });
    setCartData(updatedCartData);
  };

  const checkOut = () => {
    let paymentType = "";
    if (selectedType === "Cash On Delivery") {
      paymentType = 1;
    } else if (selectedType === "Pay On Credit") {
      paymentType = 2;
    }

    const data = {
      price: itemTotal,
      payment_type: paymentType,
    };

    console.log(data);

    axios
      .post("http://api.meddaily.in/checkout", data, {
        headers: { token: sessionStorage.getItem("token") },
      })
      .then((response) => {
        console.log("--------------------", response.data);
        setOrderSuccess(true);
        setTimeout(() => {
          setOrderSuccess(false);
          navigate("/home");
        }, 3000);
      })
      .catch((error) => {
        alert("Error");
        console.log("error:", error);
      });
  };

  const removeCartItem = (id) => {
    const token = sessionStorage.getItem("token");

    const requestBody = {
      cart_id: cartData[0]._id,
    };

    const headers = {
      token: token,
    };

    axios
      .delete("http://api.meddaily.in/delete_cart", {
        headers: headers,
        data: requestBody,
      })
      .then((response) => {
        // console.log("Item removed successfully");
        // alert("Item removed successfully");
        // navigate("/home");
        setRemoveDialogOpen(true);

        // Automatically close the dialog after 3 seconds
        setTimeout(() => {
          setRemoveDialogOpen(false);
          navigate("/home");
        }, 3000);
      })
      .catch((error) => {
        console.error("Error removing item:", error);
      });
  };
  // console.log("CArt", cartData[0]._id);
  // if cart is empty
  if (cartData?.length === 0) {
    return (
      <>
        <Navbar />
        <Typography variant="h3" style={{ margin: "4% 10%" }}>
          No Cart Available
        </Typography>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            variant="outline"
            color="primary"
            onClick={() => navigate("/home")}
            style={{
              padding: "1rem 2rem",
              height: "3rem",
              color: "#ffff",
              fontSize: "16px",
              background: "#6eafab",
              borderRadius: "8px",
              outline: "none",
              border: "none",
              marginBottom: "20px",
            }}
          >
            Add Items
          </button>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      {/* {cartData && cartData.length === 0 ? */}

      <Typography variant="h3" style={{ margin: "4% 10%" }}>
        Order Summary
      </Typography>

      <div className="med-details-div">
        <div className="medicine-quantity">
          <div style={{ marginTop: "24px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Product</TableCell>
                  <TableCell align="left">Price </TableCell>
                  <TableCell align="center">Quantity</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {cartData &&
                  cartData?.length > 0 &&
                  cartData.map((cart) => (
                    <TableRow key={cart.id}>
                      <TableCell align="left">{cart.product_name}</TableCell>
                      <TableCell align="left">{cart.price}</TableCell>

                      <TableCell align="center">
                        <Button onClick={(e) => decrementQuantity(cart._id)}>
                          <RemoveIcon />
                        </Button>

                        <input
                          className="quantity-inp"
                          type="number"
                          value={cart.quantity}
                          name="quantity"
                          onChange={(e) => handleQuantityChange(cart._id, e)}
                        ></input>

                        <Button onClick={(e) => incrementQuantity(cart._id)}>
                          <AddIcon />
                        </Button>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => removeCartItem(cart._id)} // Pass the cart item ID to the removeCartItem function
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>

          <Button>+Add more items</Button>
          <div className="bill-details">
            <Typography variant="h5" mt={4}>
              <strong>Bill Details</strong>
            </Typography>
            <>
              <Typography mt={1}>
                Item Total :{" "}
                <span style={{ position: "relative", left: "150px" }}>
                  Rs.{itemTotal}
                </span>
              </Typography>
              <Typography mt={1}>
                Delivery Fee :{" "}
                <span style={{ position: "relative", left: "135px" }}>
                  Rs.{deliveryFee}
                </span>
              </Typography>
              <Typography mt={1}>
                Taxes and charges :{" "}
                <span style={{ position: "relative", left: "80px" }}>
                  Rs.{(itemTotal * applicableTax) / 100}
                </span>
              </Typography>
            </>
            <hr></hr>
            <Typography mt={1}>
              <strong>
                Order Total:{" "}
                <span style={{ position: "relative", left: "140px" }}>
                  Rs.
                  {parseFloat(
                    // (itemTotal + deliveryFee) * (1 + applicableTax / 100)
                    itemTotal + deliveryFee + (itemTotal * applicableTax) / 100
                  ).toFixed(2)}
                </span>
              </strong>
              {/* <strong> Order Total : {itemTotal - deliveryFee }</strong> */}
            </Typography>

            <div>
              <Typography variant="h5" mt={2}>
                <strong>Payment Options</strong>
              </Typography>

              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    control={<Radio size="small" />}
                    id="Cash On Delivery"
                    name="selectedType"
                    value="Cash On Delivery" // Corrected value
                    onChange={handleChangeRadio}
                    checked={selectedType === "Cash On Delivery"}
                    label="Cash On Delivery"
                  />
                  {/* <FormControlLabel
                    control={<Radio size="small" />}
                    id="Pay Now"
                    name="selectedType"
                    value="Pay Now"
                    onChange={handleChangeRadio}
                    checked={selectedType === "Pay Now"}
                    label="Pay Now"
                  /> */}
                  <FormControlLabel
                    control={<Radio size="small" />}
                    id="Pay On Credit"
                    name="selectedType"
                    value="Pay On Credit" // Corrected value
                    onChange={handleChangeRadio}
                    checked={selectedType === "Pay On Credit"}
                    label="Pay On Credit"
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <button className="proceed-btn" onClick={checkOut}>
              {" "}
              Proceed{" "}
            </button>
          </div>
        </div>

        <div className="offers-div">
          {offers.length > 0 ? (
            offers.map((item, ind) => <Offer item={item} ind={ind} />)
          ) : (
            <p>No offers available.</p>
          )}
        </div>
      </div>

      <div className="promotion">
        <div>
          <Typography variant="h5" style={{ color: "white" }}>
            One-Stop Solution To Your Medicine Supply Chain <br></br>
            Download The Med-Daily Mobile App
          </Typography>
          <img src={google} alt="logo" className="download" />
          <img src={app} alt="logo" className="download" />
        </div>
        <div className="mobile-img">
          <img src={mobile} alt="mobile_img" />
        </div>
      </div>
      <Dialog open={isOrderSuccess} onClose={() => setOrderSuccess(false)}>
        <DialogTitle>Order Placed Successfully!</DialogTitle>
        <DialogContent>
          <p>Order placed successfully!</p>
        </DialogContent>
      </Dialog>
      <Dialog
        open={isRemoveDialogOpen}
        onClose={() => setRemoveDialogOpen(false)}
      >
        <DialogTitle>Item Removed Successfully</DialogTitle>
        <DialogContent>
          <p>Item has been removed from the cart.</p>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OrderSummary;
